import { Award, Headphones, ShieldCheck, ShoppingBag, Truck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const BENEFITS = [
  { icon: ShieldCheck, title: "Secure Checkout", desc: "256-bit encryption" },
  { icon: ShoppingBag, title: "Easy Shopping", desc: "Hassle-free experience" },
  { icon: Award, title: "Quality Products", desc: "100% quality checked" },
  { icon: Truck, title: "Reliable Delivery", desc: "Pan-India express shipping" },
  { icon: Headphones, title: "Customer Support", desc: "Mon–Sat, 10am–7pm" },
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="border-b border-neutral-200/70 bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-x-4 gap-y-8 px-4 py-12 sm:grid-cols-3 sm:px-6 lg:grid-cols-5 lg:px-8">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.06}>
            <div className="flex items-center gap-3.5" data-testid={`trust-item-${i}`}>
              <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-neutral-200 bg-background">
                <b.icon size={18} strokeWidth={1.7} className="text-neutral-900" />
              </div>
              <div>
                <p className="text-sm font-semibold text-neutral-900">{b.title}</p>
                <p className="text-xs text-neutral-400">{b.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
